import { useEffect, useRef, useState } from "react";

export const useIdleTimeout = (timeoutDuration: number) => {
  const timeoutId = useRef<ReturnType<typeof setTimeout> | null>(null);
  const [isIdle, setIsIdle] = useState(false);

  const resetTimer = () => {
    if (isIdle) return;

    if (timeoutId.current) clearTimeout(timeoutId.current);

    timeoutId.current = setTimeout(() => {
      setIsIdle(true);
    }, timeoutDuration);
  };

  // function for user to reset manually
  const reset = () => {
    if (timeoutId.current) clearTimeout(timeoutId.current);
    setIsIdle(false);
  };

  useEffect(() => {
    resetTimer();

    const events = ["mousedown", "keydown", "touchstart", "scroll"];
    events.forEach((event) => document.addEventListener(event, resetTimer));

    return () => {
      if (timeoutId.current) clearTimeout(timeoutId.current);
      events.forEach((event) => document.removeEventListener(event, resetTimer));
    };
  }, [timeoutDuration, isIdle]);

  return { isIdle, reset };
};
